module.exports = __webpack_public_path__ + "static/img/hangyeli5.ad39802.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/hangyeli5.png
// module id = DL8A
// module chunks = 5